const feature = {
  NONE: 'NONE',
  TSP: 'TSP',
  DSS: 'DSS',
  OCSP: 'OCSP',
  MOBILSIGN: 'MOBILSIGN'
}

export default feature
